import { adminConstants } from "../constant/admin-constant";

const initialState = {
    loadingOrder: false,
    productsData: [],
    cartInfo: {
        order: {
            id: null
        }
    },
    orderAttributes: [],
    productsInCart: [],
    brands: [],
};

export function createOrdersReducer(state = initialState, action) {
    switch (action.type) {
        case adminConstants.GET_FILTERED_PRODUCTS_SUCCESS:
            return {
                ...state,
                productsDataAll: action.payload.products,
                // productsData: action.payload.products.data,
                productsData: action.payload.products.data ? action.payload.products.data.map(item => {return {...item, selected: false}}) : [],
                pages: action.payload.products.last_page,
                loadingOrder: false,
                current_page: action.payload.products.current_page,
                total_orders: action.payload.products.total,

                products_pages: action.payload.products.last_page,
                products_current_page: action.payload.products.current_page,

                productsInCart: action.payload.cart_product_ids
            };
        case adminConstants.GET_ORDER_PRODUCTS_SUCCESS:
            return {
                ...state,
                productsDataAll: action.payload.products,
                productsData: action.payload.products !== undefined ? action.payload.products.data : [],
                pages: action.payload.products.last_page,
                loadingOrder: false,
                current_page: action.payload.products.current_page,
                total_orders: action.payload.products.total
            };
        case adminConstants.ADD_PRODUCTS_TO_CART_SUCCESS:
            return {
                ...state,
                cartInfo: action.payload
            };
        case adminConstants.GET_ORDER_ATTRIBUTES_SUCCESS:
            return {
                ...state,
                orderAttributes: action.payload.attributes
            };
        case adminConstants.GET_CUSTOMER_BRANDS_FOR_CREATE_ORDER_SUCCESS:
            return {
                ...state,
                brands: action.payload.result.brands
            };
        default:
            return {
                ...state
            };
    }
}



// WEBPACK FOOTER //
// ./src/redux/reducers/CreateOrderReducer.jsx